import { useCallback, useState } from 'react';

const useLoadingState = () => {
  const [loadingActions, setLoadingActions] = useState(new Map());

  const setLoading = useCallback((key, value) => {
    setLoadingActions((prev) => {
      const newLoadingActions = new Map(prev);
      newLoadingActions.set(key, value);

      return newLoadingActions;
    });
  }, []);

  const isLoading = useCallback((key) => loadingActions.get(key) || false, [loadingActions]);

  return { setLoading, isLoading };
};

export default useLoadingState;
